import URL from "@/constants/baseurl";

export default {
    namespaced: true,
    state: () => ({
        branches: [],

        branch_filters: {
            name: '',
            page: 1,
        }

    }),
    mutations: {
        SET_BRANCHES(state, branches) {
            state.branches = branches;
        }

    },
    actions: {

        set_branches({ commit }, data) {
            commit('SET_BRANCHES', data);
        },

        async get_branches({ state, commit }) {
            const apiToken = localStorage.getItem('token');
            const url = `${URL.BASEURL}/api/get-branches`;

            let filters = {
                name: state.branch_filters.name,
                page: state.branch_filters.page,
            };

            try {
                const response = await fetch(url, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${apiToken}`
                    },
                    body: JSON.stringify(filters)
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }

                const res = await response.json();
                commit('SET_BRANCHES', res);
            } catch (error) {
                console.error('Error fetching branches:', error);
            }
        }

    },
    getters: {}
}
